import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import orderBy from 'lodash/orderBy';

import { SortedFilteredList } from '../classes/sorted-filtered-list.class';
import { IList, IListState } from '../models';


export function applyListPaging<T, S>(
	list: IList<T>,
	props: Partial<IListState<S>>,
	sorters?: Record<string, CallableFunction>
): SortedFilteredList<T, S> {
	let items = list.items.slice();
	const newList = new SortedFilteredList<T, S>();
	newList.setList(list);

	// handle sort
	if (props.sorts?.length) {
		if (sorters) {
			const sortFns = props.sorts.map(s => sorters[''+s.prop]);
			items = orderBy(items, sortFns, props.sorts.map(s => s.isDesc ? 'desc' : 'asc')) as T[]
		} else {
			items = orderBy(items, props.sorts.map(s => s.prop), props.sorts.map(s => s.isDesc ? 'desc' : 'asc')) as T[]
		}
		newList.setList({ ...list, items });
		newList.setPageSize(items.length);
		newList.setSorts(props.sorts);
	}

	return newList;
}

export function makeSortedList<TList extends IList<TItem>, TItem, TSortProp>(
	list: TList, state: IListState<TSortProp>): SortedFilteredList<TItem, TSortProp> {
	const sortedList = new SortedFilteredList<TItem, TSortProp>();

	if (state) {
		sortedList.setList(list);
		if (state.sorts) sortedList.setSorts(state.sorts);
		sortedList.setPageSize(state.pageSize ?? state.originalPageSize ?? 5, state.originalPageSize);
		sortedList.setPageNumber(state.page ?? 1);
	}
	return sortedList;
}

export function combineToList<TList extends IList<TItem>, TItem, TSortProp>(
	list$: Observable<TList>,
	paging$: Observable<IListState<TSortProp>>
): Observable<SortedFilteredList<TItem, TSortProp>> {
	return combineLatest([ list$, paging$ ]).pipe(
		map(([list, paging]) => makeSortedList(list, paging))
	);
}
